const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

function isoDate(date) {
  return date.toISOString().slice(0, 10);
}

function addUtcDays(iso, days) {
  const date = new Date(`${iso}T00:00:00.000Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return isoDate(date);
}

function isoMonday(iso) {
  const date = new Date(`${iso}T00:00:00.000Z`);
  const offset = (date.getUTCDay() + 6) % 7;
  date.setUTCDate(date.getUTCDate() - offset);
  return isoDate(date);
}

function previousCompletedWeekStart() {
  const today = isoDate(new Date());
  return addUtcDays(isoMonday(today), -7);
}

export const GL_MANAGER_DEFAULT_WEEK_START = previousCompletedWeekStart();
export const GL_MANAGER_DEFAULT_WEEK_END = addUtcDays(
  GL_MANAGER_DEFAULT_WEEK_START,
  6
);

function normalizedRequestedWeekStart(requestedStart, requestedEnd) {
  if (!ISO_DATE.test(requestedStart)) return GL_MANAGER_DEFAULT_WEEK_START;

  const start = new Date(`${requestedStart}T00:00:00.000Z`);
  const end = ISO_DATE.test(requestedEnd)
    ? new Date(`${requestedEnd}T00:00:00.000Z`)
    : null;

  /* Repair legacy Sunday-Saturday URLs caused by local-time date handling. */
  if (
    start.getUTCDay() === 0 &&
    (!end ||
      (end.getUTCDay() === 6 &&
        (end.getTime() - start.getTime()) / 86400000 === 6))
  ) {
    return addUtcDays(requestedStart, 1);
  }

  return isoMonday(requestedStart);
}

export function managerWeekFromSearch(searchParams) {
  const requestedStart = searchParams?.get?.("weekStart") || "";
  const requestedEnd = searchParams?.get?.("weekEnd") || "";

  const weekStart = normalizedRequestedWeekStart(requestedStart, requestedEnd);

  return { weekStart, weekEnd: addUtcDays(weekStart, 6) };
}

export function managerPathWithWeek(pathname, weekStart, weekEnd) {
  const normalized = managerWeekFromSearch(
    new URLSearchParams({ weekStart: weekStart || "", weekEnd: weekEnd || "" })
  );
  const params = new URLSearchParams({
    weekStart: normalized.weekStart,
    weekEnd: normalized.weekEnd,
  });

  return `${pathname}?${params.toString()}`;
}
